import { render } from "./BottomNavbarLink.vue?vue&type=template&id=0cce7758&scoped=true"
import script from "./BottomNavbarLink.vue?vue&type=script&lang=js"
export * from "./BottomNavbarLink.vue?vue&type=script&lang=js"

import "./BottomNavbarLink.vue?vue&type=style&index=0&id=0cce7758&scoped=true&lang=scss"

import exportComponent from "D:\\repos\\multihabit-webclient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cce7758"]])

export default __exports__